import React from "react";
import classNames from "classnames";
import "./WidgetToolbarButton.scss";

export interface IWidgetToolbarButton {
    iconClass: string;
    buttonClass?: string;
    title: string;
    onClick: (e) => void;
}

export const WidgetToolbarButton = ({ iconClass, buttonClass, onClick, title }: IWidgetToolbarButton): JSX.Element => (
    <div className={classNames("widget-toolbar-button", buttonClass)} onClick={onClick} title={title}>
        <span className={iconClass}></span>
    </div>
);
